import { render, staticRenderFns } from "./StudentFeesList.vue?vue&type=template&id=015457fc"
import script from "./StudentFeesList.vue?vue&type=script&lang=js"
export * from "./StudentFeesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports